import { render, staticRenderFns } from "./SelectedBillsTable.vue?vue&type=template&id=1a8050a0"
import script from "./SelectedBillsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectedBillsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports